import type {
  AppointmentCreateOutputs,
  AppointmentCreateStepId,
  AppointmentCreateWorkflowEvent,
} from "../../../_logic/create-appointment-contract"

export const appointmentCreateStepIndex = (step: AppointmentCreateStepId): number =>
  ["general", "planning", "announcement"].indexOf(step)

export const applyAppointmentCreateWorkflowEvent = (
  outputs: AppointmentCreateOutputs,
  event: AppointmentCreateWorkflowEvent,
): AppointmentCreateOutputs => {
  if (event.type === "general.completed") {
    return { general: event.output }
  }

  if (event.type === "general.work_order_created") {
    return { ...outputs, general: event.output }
  }

  if (event.type === "planning.completed") {
    return { ...outputs, planning: event.output }
  }

  return outputs
}

export const nextAppointmentCreateStep = (
  current: AppointmentCreateStepId,
  event: AppointmentCreateWorkflowEvent,
): AppointmentCreateStepId => {
  if (event.type === "go_to_step") return event.step

  if (event.type === "general.completed") return "planning"

  if (event.type === "planning.completed") return "announcement"

  return current
}
